module.exports = __webpack_public_path__ + "img/rightCircle.334c7a75.svg";